import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Task } from '../types';
import { taskTemplates as defaultTemplates } from '../data/taskTemplates';

interface TaskTemplateStore {
  templates: Record<string, Task[]>;
  updateTemplates: (stageId: string, tasks: Task[]) => void;
  getTemplatesForStage: (stageId: string) => Task[];
  resetToDefaults: () => void;
}

export const useTaskTemplateStore = create<TaskTemplateStore>()(
  persist(
    (set, get) => ({
      templates: defaultTemplates,
      updateTemplates: (stageId, tasks) => 
        set((state) => ({
          templates: {
            ...state.templates,
            [stageId]: tasks,
          },
        })),
      getTemplatesForStage: (stageId) => {
        const { templates } = get();
        return templates[stageId] || defaultTemplates[stageId] || [];
      },
      resetToDefaults: () => set({ templates: defaultTemplates }),
    }),
    {
      name: 'task-templates',
      onRehydrateStorage: () => (state) => {
        // Ensure all default templates are present
        if (state) {
          const templates = { ...defaultTemplates };
          // Merge with stored templates, preferring stored ones
          Object.keys(state.templates).forEach(stageId => {
            templates[stageId] = state.templates[stageId];
          });
          state.templates = templates;
        }
      },
    }
  )
);